import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ConfirmationWithAuthenticationModalComponent, type ConfirmationWithAuthenticationModalProps,
} from './confirmationWithAuthenticationModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ConfirmationWithAuthentication: ConfirmationWithAuthenticationModalProps;
  }
}
modalRenderer.register('ConfirmationWithAuthentication', ConfirmationWithAuthenticationModalComponent);
